"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SampleDataSubheading_1 = require("./SampleDataSubheading");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return SampleDataSubheading_1.default; } });
